export const oneSecond = 1000;
export const tenSeconds = 10000;
export const oneMinute = 60000;
export const twoMinutes = 120000;
export const oneHour = 3600000;
export const oneDay = 86400000;
